var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-3"},[_c('ScoreTable',{attrs:{"quizID":_vm.quizCode,"externalFields":_vm.externalFields}}),_c('TopQuizChat',{attrs:{"quizID":_vm.quizID,"quizHost":_vm.quizHost}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }